import { useQuery } from '@tanstack/react-query'

import { getCreditCardCrossSelling } from './functions'

const useCreditCardCrossSelling = (customerId: number, partnerId: number) => {
  return useQuery(
    ['creditCardCrossSelling', { customerId, partnerId }],
    () => getCreditCardCrossSelling(customerId, partnerId),
    {
      enabled: Boolean(customerId),
    }
  )
}

export { useCreditCardCrossSelling }
